import React from "react";
import { QRCodeSVG } from "qrcode.react";

/**
 * 全家寄件編號 QR + 機台交件步驟(純顯示)。
 *
 * 歸還完成畫面(FamiReturnQrc)與會員中心「歸還紀錄」重看都用這一份,
 * 文案只維護一處。QR 與畫面顯示都是 11 碼 OrderNo(全家窗口 2026-07-24 確認機台收 11 碼)。
 */
interface Props {
  orderNo: string;
  /** 交件期限(yyyy-mm-dd),沒有就顯示「申請後 5 日內」 */
  expiresAt?: string | null;
  compact?: boolean;
}

const wrap: React.CSSProperties = {
  width: "100%",
  maxWidth: 360,
  margin: "0 auto",
  textAlign: "center",
};
const qrBox: React.CSSProperties = {
  display: "inline-block",
  padding: 12,
  background: "#fff",
  border: "1px solid #eee",
  borderRadius: 12,
};
const shipNoStyle: React.CSSProperties = {
  marginTop: 10,
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: 2,
  color: "#111",
};
const shipNoLabel: React.CSSProperties = {
  marginTop: 2,
  fontSize: 13,
  color: "#008a45",
  fontWeight: 600,
};
const stepsBox: React.CSSProperties = {
  margin: "18px auto 0",
  padding: "14px 16px",
  background: "#f6f8f7",
  borderRadius: 12,
  textAlign: "left",
};
const stepsTitle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 700,
  color: "#111",
  marginBottom: 8,
};
const stepItem: React.CSSProperties = {
  fontSize: 14,
  lineHeight: 1.7,
  color: "#333",
};
const tips: React.CSSProperties = {
  marginTop: 12,
  fontSize: 12.5,
  lineHeight: 1.6,
  color: "#c0392b",
};

export const famiDeadlineText = (expiresAt?: string | null): string =>
  expiresAt ? `請於 ${expiresAt.slice(0, 10)} 前寄出` : "請於申請後 5 日內寄出";

const FamiShipQr: React.FC<Props> = ({ orderNo, expiresAt, compact }) => (
  <div style={wrap}>
    <div style={qrBox}>
      <QRCodeSVG value={orderNo} size={compact ? 160 : 200} includeMargin />
    </div>
    <p style={shipNoStyle}>{orderNo}</p>
    <p style={shipNoLabel}>寄件編號</p>

    <div style={stepsBox}>
      <div style={stepsTitle}>到全家門市這樣交件</div>
      <div style={stepItem}>① 把循環箱/袋裝好,確認外包裝完整</div>
      <div style={stepItem}>② 帶到任一間全家便利商店</div>
      <div style={stepItem}>
        ③ 於店內 FamiPort 機台點選「服務/寄件」→「循環袋退貨」→「循環包材歸還」,
        依指示掃描上方 QRCode(或手動輸入寄件編號),取得機台列印的寄件單據
      </div>
      <div style={stepItem}>④ 將單據貼在要歸還的包裝上,交給店員掃描,即完成交件</div>
    </div>

    <p style={tips}>
      ⚠ {famiDeadlineText(expiresAt)},外包裝需完整;此寄件編號限用一次。
    </p>
  </div>
);

export default FamiShipQr;
